import React from 'react'
import { ScaleLoader } from 'react-spinners'

function Loader() {
  return (
      <div className="flex justify-center items-center h-64">
          <ScaleLoader color="#FFAE00" height={40} />
      </div>
  )
}

export default Loader